import React, { Component } from 'react';
import { elements } from './_data_safety_layout';

export default class DayQualityElement extends Component {
  state = {
    hover: false,
  };

  openInfo = (event) => {
    this.props.showInfo(this.props.num);
  };

  onMouseEnter = (event) => {
    this.setState({ hover: true });
  };

  onMouseLeave = (event) => {
    this.setState({ hover: false });
  };

  render() {
    let { num } = this.props;
    let { color } = this.props;
    let { issues } = this.props;
    // console.log('Quality: num %d, lastClicked %d, lastGroupClicked %d', num, this.props.lastClickedElement, this.props.lastGroupClicked)
    return (
      <div
        title={num}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={this.openInfo}
        className={`${
          this.props.oneTypeIssue == true ? 'element-one-type-issue' : 'element'
        } element_quality-${num} ${color} ${
          this.state.hover || (this.props.lastClickedElement == num && this.props.lastGroupClicked == 2) ? 'active' : ''
        }`}
        style={{ background: `${color}` }}
      >
        {/* <div className="number">{element.number}</div> */}
        <div className="symbol">{num}</div>
        {/* <div className="element-name">{element.name}</div> */}
      </div>
    );
  }
}
